import Services from "../services/Services";


export default class CEPHelper {

	static get consultarCEP() {
		let _cep = '';

		function get(cep, object) {
			return new Promise((resolve, reject) => {
				try {
					cep = cep.replace(/-/g, '');

					if (cep.length === 8) {

						if (_cep === cep) {
							return null;
						}

						_cep = cep;

						Services.CEPService.consultarCEP(cep)
						.then(response => {
							const endereco = response.data;

							if (endereco.cep === cep) {
								object.logradouro = endereco.logradouro;
								object.bairro = endereco.bairro;
								object.cidade = endereco.cidade;
								object.estado = endereco.estado;
							}

							return resolve();
						})
						.catch(error => {
							_cep = '';
							return reject(error);
						});

					} else {
						return resolve();
					}

				} catch (error) {
					_cep = '';
					return reject(error);
				}
			});
		}

		return { get };
	}
}
